export default "__VITE_ASSET__ClnpgDyt__"